export class TimeOfYear {
    'month';
    'dayOfMonth';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "month",
            "baseName": "month",
            "type": "number",
            "format": ""
        },
        {
            "name": "dayOfMonth",
            "baseName": "dayOfMonth",
            "type": "number",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TimeOfYear.attributeTypeMap;
    }
    constructor() {
    }
}
